import { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import { createPortal } from 'react-dom';
import { Tooltip } from 'antd';

const MultiMarker = ({
  map,
  feature,
  onClick,
  isActive = false,
  isCombined = false,
}) => {
  const { latitude, longitude, title, color, type } = feature;
  console.log(feature);

  const markerRef = useRef();
  const contentRef = useRef(document.createElement('div'));

  useEffect(() => {
    markerRef.current = new mapboxgl.Marker(contentRef.current)
      .setLngLat([longitude, latitude])
      .addTo(map);

    return () => {
      markerRef.current.remove();
    };
  }, []);

  return (
    <>
      {createPortal(
        <Tooltip title={title} overlayClassName='map-tooltip'>
          <div
            onClick={() => onClick(feature)}
            style={{
              cursor: 'pointer',
              display: 'inline-block',
              fontFamily: 'ShabnamFD',
              fontSize: '14px',
              fontWeight: 'bold',
              color: isActive || type === 'مشتری' ? '#ffffff' : '#5a5a5a',
              textAlign: 'center',
            }}
          >
            {type === 'نقطه سرویس' && feature?.timePrivacyType === 2 ? (
              <svg
                width='62'
                height='62'
                viewBox='0 0 43 32'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <g filter='url(#filter0_d_1155_862)'>
                  <circle cx='21' cy='16' r='10' fill='#132A49' />
                  <circle
                    cx='21'
                    cy='16'
                    r='11'
                    stroke='#ECF4FF'
                    stroke-opacity='0.61'
                    stroke-width='2'
                  />
                </g>
                <path
                  d='M18.1687 12.9062L17.557 14.5714H24.443L23.8312 12.9062C23.7258 12.6205 23.4422 12.4286 23.1234 12.4286H18.8766C18.5578 12.4286 18.2742 12.6205 18.1687 12.9062ZM15.9281 14.6786L16.7531 12.4353C17.0695 11.5759 17.9203 11 18.8766 11H23.1234C24.0797 11 24.9305 11.5759 25.2469 12.4353L26.0719 14.6786C26.6156 14.8929 27 15.404 27 16V20.2857C27 20.6808 26.6648 21 26.25 21H25.5C25.0852 21 24.75 20.6808 24.75 20.2857V19.5714H17.25V20.2857C17.25 20.6808 16.9148 21 16.5 21H15.75C15.3352 21 15 20.6808 15 20.2857V16C15 15.404 15.3844 14.8929 15.9281 14.6786ZM18 17.0714C18 16.6763 17.6648 16.3571 17.25 16.3571C16.8352 16.3571 16.5 16.6763 16.5 17.0714C16.5 17.4665 16.8352 17.7857 17.25 17.7857C17.6648 17.7857 18 17.4665 18 17.0714ZM24.75 17.7857C25.1648 17.7857 25.5 17.4665 25.5 17.0714C25.5 16.6763 25.1648 16.3571 24.75 16.3571C24.3352 16.3571 24 16.6763 24 17.0714C24 17.4665 24.3352 17.7857 24.75 17.7857Z'
                  fill='white'
                />
                <defs>
                  <filter
                    id='filter0_d_1155_862'
                    x='6'
                    y='1'
                    width='30'
                    height='30'
                    filterUnits='userSpaceOnUse'
                    color-interpolation-filters='sRGB'
                  >
                    <feFlood flood-opacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                      in='SourceAlpha'
                      type='matrix'
                      values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                      result='hardAlpha'
                    />
                    <feMorphology
                      radius='3'
                      operator='dilate'
                      in='SourceAlpha'
                      result='effect1_dropShadow_1155_862'
                    />
                    <feOffset />
                    <feColorMatrix
                      type='matrix'
                      values='0 0 0 0 0.0745098 0 0 0 0 0.164706 0 0 0 0 0.286275 0 0 0 0.65 0'
                    />
                    <feBlend
                      mode='normal'
                      in2='BackgroundImageFix'
                      result='effect1_dropShadow_1155_862'
                    />
                    <feBlend
                      mode='normal'
                      in='SourceGraphic'
                      in2='effect1_dropShadow_1155_862'
                      result='shape'
                    />
                  </filter>
                </defs>
              </svg>
            ) : type === 'نقطه سرویس' && feature?.timePrivacyType === 1 ? (
              <svg
                width='70'
                height='70'
                viewBox='0 0 72 54'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <g filter='url(#filter0_d_1155_524)'>
                  <circle cx='36' cy='27' r='15' fill='#FEC934' />
                  <circle
                    cx='36'
                    cy='27'
                    r='17'
                    stroke='#FFFBEF'
                    stroke-opacity='0.61'
                    stroke-width='4'
                  />
                </g>
                <path
                  d='M31.47 21.8026L30.4912 24.6001H41.5087L40.53 21.8026C40.3612 21.3226 39.9075 21.0001 39.3975 21.0001H32.6025C32.0925 21.0001 31.6387 21.3226 31.47 21.8026ZM27.885 24.7801L29.205 21.0113C29.7112 19.5676 31.0725 18.6001 32.6025 18.6001H39.3975C40.9275 18.6001 42.2887 19.5676 42.795 21.0113L44.115 24.7801C44.985 25.1401 45.6 25.9988 45.6 27.0001V34.2001C45.6 34.8638 45.0637 35.4001 44.4 35.4001H43.2C42.5362 35.4001 42 34.8638 42 34.2001V33.0001H30V34.2001C30 34.8638 29.4637 35.4001 28.8 35.4001H27.6C26.9362 35.4001 26.4 34.8638 26.4 34.2001V27.0001C26.4 25.9988 27.015 25.1401 27.885 24.7801ZM31.2 28.8001C31.2 28.1363 30.6637 27.6001 30 27.6001C29.3362 27.6001 28.8 28.1363 28.8 28.8001C28.8 29.4638 29.3362 30.0001 30 30.0001C30.6637 30.0001 31.2 29.4638 31.2 28.8001ZM42 30.0001C42.6637 30.0001 43.2 29.4638 43.2 28.8001C43.2 28.1363 42.6637 27.6001 42 27.6001C41.3362 27.6001 40.8 28.1363 40.8 28.8001C40.8 29.4638 41.3362 30.0001 42 30.0001Z'
                  fill='white'
                />
                <defs>
                  <filter
                    id='filter0_d_1155_524'
                    x='14'
                    y='5'
                    width='44'
                    height='44'
                    filterUnits='userSpaceOnUse'
                    color-interpolation-filters='sRGB'
                  >
                    <feFlood flood-opacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                      in='SourceAlpha'
                      type='matrix'
                      values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                      result='hardAlpha'
                    />
                    <feMorphology
                      radius='3'
                      operator='dilate'
                      in='SourceAlpha'
                      result='effect1_dropShadow_1155_524'
                    />
                    <feOffset />
                    <feColorMatrix
                      type='matrix'
                      values='0 0 0 0 0.996078 0 0 0 0 0.788235 0 0 0 0 0.203922 0 0 0 0.65 0'
                    />
                    <feBlend
                      mode='normal'
                      in2='BackgroundImageFix'
                      result='effect1_dropShadow_1155_524'
                    />
                    <feBlend
                      mode='normal'
                      in='SourceGraphic'
                      in2='effect1_dropShadow_1155_524'
                      result='shape'
                    />
                  </filter>
                </defs>
              </svg>
            ) : type === 'مشتری' ? (
              <svg
                width='72'
                height='54'
                viewBox='0 0 72 54'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <g filter='url(#filter0_d_1155_218)'>
                  <circle cx='36' cy='27' r='15' fill='#00528C' />
                  <circle
                    cx='36'
                    cy='27'
                    r='17'
                    stroke='#ECF4FC'
                    stroke-width='4'
                  />
                </g>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M43.5 34.5C43.5 34.0398 43.1269 33.6667 42.6667 33.6667V25C42.6667 24.5333 42.6667 24.2999 42.5758 24.1217C42.4959 23.9649 42.3685 23.8374 42.2117 23.7575C42.0334 23.6667 41.8 23.6667 41.3333 23.6667H40.1667V33.6667H39.3333V23.6667V21.3333C39.3333 20.3999 39.3333 19.9332 39.1517 19.5767C38.9919 19.2631 38.7369 19.0081 38.4233 18.8483C38.0668 18.6667 37.6001 18.6667 36.6667 18.6667H34.8889C34.3722 18.6667 34.1139 18.6667 33.902 18.7234C33.3268 18.8776 32.8776 19.3268 32.7235 19.902C32.6667 20.1139 32.6667 20.3722 32.6667 20.8889C32.6667 21.1472 32.6667 21.2764 32.6383 21.3823C32.5612 21.6699 32.3366 21.8945 32.049 21.9716C31.943 22 31.8139 22 31.5556 22C31.0389 22 30.7806 22 30.5686 22.0568C29.9935 22.2109 29.5442 22.6601 29.3901 23.2353C29.3333 23.4472 29.3333 23.7056 29.3333 24.2222V33.6667C28.8731 33.6667 28.5 34.0398 28.5 34.5C28.5 34.9602 28.8731 35.3333 29.3333 35.3333H42.6667C43.1269 35.3333 43.5 34.9602 43.5 34.5ZM36.8333 22.4167C36.8333 21.9564 36.4602 21.5833 36 21.5833C35.5398 21.5833 35.1667 21.9564 35.1667 22.4167V22.425C35.1667 22.8852 35.5398 23.2583 36 23.2583C36.4602 23.2583 36.8333 22.8852 36.8333 22.425V22.4167ZM32.6667 24.5C32.2064 24.5 31.8333 24.8731 31.8333 25.3333C31.8333 25.7936 32.2064 26.1667 32.6667 26.1667H36C36.4602 26.1667 36.8333 25.7936 36.8333 25.3333C36.8333 24.8731 36.4602 24.5 36 24.5H32.6667ZM32.6667 27.4167C32.2064 27.4167 31.8333 27.7898 31.8333 28.25C31.8333 28.7102 32.2064 29.0833 32.6667 29.0833H36C36.4602 29.0833 36.8333 28.7102 36.8333 28.25C36.8333 27.7898 36.4602 27.4167 36 27.4167H32.6667ZM32.6667 30.3333C32.2064 30.3333 31.8333 30.7064 31.8333 31.1667C31.8333 31.6269 32.2064 32 32.6667 32H36C36.4602 32 36.8333 31.6269 36.8333 31.1667C36.8333 30.7064 36.4602 30.3333 36 30.3333H32.6667Z'
                  fill='white'
                />
                <defs>
                  <filter
                    id='filter0_d_1155_218'
                    x='14'
                    y='5'
                    width='44'
                    height='44'
                    filterUnits='userSpaceOnUse'
                    color-interpolation-filters='sRGB'
                  >
                    <feFlood flood-opacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                      in='SourceAlpha'
                      type='matrix'
                      values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                      result='hardAlpha'
                    />
                    <feMorphology
                      radius='3'
                      operator='dilate'
                      in='SourceAlpha'
                      result='effect1_dropShadow_1155_218'
                    />
                    <feOffset />
                    <feColorMatrix
                      type='matrix'
                      values='0 0 0 0 0.698039 0 0 0 0 0.835294 0 0 0 0 1 0 0 0 0.65 0'
                    />
                    <feBlend
                      mode='normal'
                      in2='BackgroundImageFix'
                      result='effect1_dropShadow_1155_218'
                    />
                    <feBlend
                      mode='normal'
                      in='SourceGraphic'
                      in2='effect1_dropShadow_1155_218'
                      result='shape'
                    />
                  </filter>
                </defs>
              </svg>
            ) : (
              <svg
                width='72'
                height='54'
                viewBox='0 0 72 54'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <g filter='url(#filter0_d_1155_360)'>
                  <circle cx='36' cy='27' r='15' fill='#C23939' />
                  <circle
                    cx='36'
                    cy='27'
                    r='17'
                    stroke='#FFE8E8'
                    stroke-opacity='0.6'
                    stroke-width='4'
                  />
                </g>
                <path
                  d='M36 26.75C38.0719 26.75 39.75 25.0719 39.75 23C39.75 20.9281 38.0719 19.25 36 19.25C33.9281 19.25 32.25 20.9281 32.25 23C32.25 25.0719 33.9281 26.75 36 26.75ZM35.0719 28.5C31.9937 28.5 29.5 30.9937 29.5 34.0719C29.5 34.5844 29.9156 35 30.4281 35H41.5719C42.0844 35 42.5 34.5844 42.5 34.0719C42.5 30.9937 40.0063 28.5 36.9281 28.5H35.0719Z'
                  fill='white'
                />
                <defs>
                  <filter
                    id='filter0_d_1155_360'
                    x='14'
                    y='5'
                    width='44'
                    height='44'
                    filterUnits='userSpaceOnUse'
                    color-interpolation-filters='sRGB'
                  >
                    <feFlood flood-opacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                      in='SourceAlpha'
                      type='matrix'
                      values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                      result='hardAlpha'
                    />
                    <feMorphology
                      radius='3'
                      operator='dilate'
                      in='SourceAlpha'
                      result='effect1_dropShadow_1155_360'
                    />
                    <feOffset />
                    <feColorMatrix
                      type='matrix'
                      values='0 0 0 0 0.760784 0 0 0 0 0.223529 0 0 0 0 0.223529 0 0 0 0.65 0'
                    />
                    <feBlend
                      mode='normal'
                      in2='BackgroundImageFix'
                      result='effect1_dropShadow_1155_360'
                    />
                    <feBlend
                      mode='normal'
                      in='SourceGraphic'
                      in2='effect1_dropShadow_1155_360'
                      result='shape'
                    />
                  </filter>
                </defs>
              </svg>
            )}
          </div>
        </Tooltip>,
        contentRef.current
      )}
    </>
  );
};

export default MultiMarker;
